import React from 'react'
import { SVGIconProps } from '../types'
const SvgSignalWifiStatusbarNull26X24Px = ({
  size = 16,
  ...props
}: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="#233745"
        fillRule="nonzero"
        d="M8 3.077c2.615 0 4.69.93 5.957 1.692L8 12.185 2.05 4.769C3.31 4.006 5.384 3.077 8 3.077m0-1.23C3.532 1.846.554 4.282.258 4.504l7.736 9.637.006.012.006-.006 7.736-9.643C15.446 4.283 12.468 1.846 8 1.846"
      />
    </g>
  </svg>
)
export default SvgSignalWifiStatusbarNull26X24Px
